import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CoursePicker from '../../../components/CoursePicker';
import CourseCarousel from '../../../components/CourseCarousel';
import HowItWorksVideo from '../../../components/HowItWorksVideo';
// import HomePageRemainder from '../../../components/HomePageRemainder';
import TestimonialsCarousel from '../../../components/TestimonialsCarousel';
import imgLindsey from '../../../img/testimonial-lindsay-foster.jpg';
import imgSignatureLogo from '../../../img/signature-logo.png';
import imgMichelle from '../../../img/testimonial-michelle-jones.jpg';
import imgIBSLLogo from '../../../img/ibsl-logo.png';
import imgJames from '../../../img/user-illustrations/james.png';
import imgSteph from '../../../img/user-illustrations/steph.png';
import imgSarah from '../../../img/user-illustrations/sarah.png';
import imgGraham from '../../../img/user-illustrations/graham.png';
import img1 from '../../../img/benefit-list/1.png';
import img2 from '../../../img/benefit-list/2.png';
import img3 from '../../../img/benefit-list/3.jpg';
import img4 from '../../../img/benefit-list/4.jpg';

class Home extends Component {
  render () {
    return (
      <span>
        <CoursePicker rootPath='/' />
        <main className='main'>
          <HowItWorksVideo />
          <CourseCarousel courses={this.props.courses} />
          <section className='highlighted-section highlighted-section--xdark'>
            <div className='l-container l-container--narrow'>
              <blockquote className='testimonial'>
                <p>Student support is great; the course is professional and organised and the service is very personal and understanding.</p>
                <cite>Ruth Marchewicz, Level 6 NVQ Certificate in BSL</cite>
              </blockquote>
            </div>
          </section>

          <section className='l-container l-container--narrow'>
            <blockquote className='featured-testimonial featured-testimonial--has-image'>
              <p>We want to increase the number of fluent and professional BSL users across the UK. BSLcourses.co.uk contributes to this by providing accessible and flexible online teaching for students studying for Signature’s Level 6 BSL qualification.</p>
              <footer>
                <img src={imgLindsey} alt='Lindsay Foster, CEO, Signature' />
                <cite>Lindsay Foster, CEO, Signature</cite>
                <img src={imgSignatureLogo} alt='Signature logo' />
              </footer>
            </blockquote>

            <blockquote className='featured-testimonial featured-testimonial--has-image'>
              <p>IBSL would like to congratulate BSLcourses.co.uk for their hard work and dedication in developing a market leading initiative and in establishing a range of online accredited courses. We are proud to be an awarding organisation working alongside BSLcourses.co.uk and we wish them every success in the future.</p>
              <footer>
                <img src={imgMichelle} alt='Michelle Jones, CEO, Institute of British Sign Language (IBSL)' />
                <cite>Michelle Jones, CEO, Institute of British Sign Language (IBSL)</cite>
                <img src={imgIBSLLogo} alt='iBSL logo' />
              </footer>
            </blockquote>
          </section>

          <section className='is-bsl-right'>
            <div className='l-container l-container--narrow'>
              <h1 className='alpha'>Is BSL Courses right for me?</h1>
              <p>We offer a wide range of British Sign Language courses for all abilities and they are taught through our online platform, so you’re free to learn at your own pace. BSL Courses is perfect if you…</p>
              <ul className='big-list tick-list js-inview-bottom is-inview'>
                <li>Are looking for a flexible way to learn at your own pace. No more trying to fit your life around evening classes or driving to out-of-the-way colleges</li>
                <li>Want to communicate with a Deaf family member or friend and have
                no prior experience</li>
                <li>Are looking to start (or progress in) a career working with Deaf people</li>
                <li>Need to top up your professional qualifications</li>
                <li>Want to receive nationally recognised certifications </li>
                <li>Value having a great support team who are available to help you with any questions or advice</li>
              </ul>
            </div>

            <div className='is-bsl-right__users'>
              <div>
                <img src={imgJames} alt='User illustration' />
                <p>James is a professional interpreter at Level 6 who needs to stay on top of his game.</p>
              </div>
              <div>
                <img src={imgSteph} alt='User illustration' />
                <p>Steph is a support worker who wants to expand her careers options by learning BSL.</p>
              </div>
              <div>
                <img src={imgSarah} alt='User illustration' />
                <p>Sarah is a busy mother who wants to learn absic BSL to communicate with her deaf nephew.</p>
              </div>
              <div>
                <img src={imgGraham} alt='User illustration' />
                <p>Graham is a receptionist, undertaking Deaf Awareness Training to better help his guests.</p>
              </div>
            </div>
          </section>

          <section className='benefit-list'>
            <div className='benefit-list__benefit'>
              <div className='l-container'>
                <div className='benefit-list__content'>
                  <h2 className='epsilon'>Fun bite-size classes</h2>
                  <h3>Learn British Sign Language at your own pace in a range of styles - videos, slideshows and more.</h3>
                  <p>Learn everything you need to know from BSL to deaf awareness. Beginner to fluent. Course material is structured to guide and improve your signing skills all the way. Prepare skills for quizzes and tutorials throughout the course.</p>
                </div>
                <div className='benefit-list__image'>
                  <img src={img1} alt='Screenshot of the BSLcourses app' />
                </div>
              </div>
            </div>

            <div className='l-container l-container--narrow'>
              <blockquote className='testimonial'>
                <p>After I finished my Level 6 BSL Training course, this was so quick to finish as there are only the assessments to complete, very minimal paperwork. I sincerely commend the staff who have put together this course allowing me to finally register as a Trainee Interpreter and I was only 19!'</p>
                <cite>Oliver Hawley, Level 6 BSL Training & Level 6 Certificate in BSL Studies</cite>
              </blockquote>
            </div>
            <hr />

            <div className='benefit-list__benefit'>
              <div className='l-container'>
                <div className='benefit-list__content'>
                  <h2 className='epsilon'>Quizzes to unlock classes</h2>
                  <h3>Complete fun quizzes to test your BSL knowledge and unlock new classes.</h3>
                  <p>Our interactive quizzes test your new signing skills and knowledge, using videos and images. Quizzes ensures you are ready to do tutorials and progress to the next set of classes.</p>
                </div>
                <div className='benefit-list__image'>
                  <img src={img2} alt='Screenshot of the BSLcourses app' />
                </div>
              </div>
            </div>

            <div className='benefit-list__benefit'>
              <div className='l-container'>
                <div className='benefit-list__content'>
                  <h2 className='epsilon'>One-to-one tutorials with professionals</h2>
                  <h3>Practice your new sign language skills and gain valuable feedback with one-to-one tutorials.</h3>
                  <p>Complete tutorials with a BSL Teacher, Practice new skills and knowledge. Receive expert feedback and tips. You will be guided through the entire course so you are ready to progress to the next Level or complete assessments (which are also done via webcam).</p>
                </div>
                <div className='benefit-list__image'>
                  <img src={img3} alt='Screenshot of the BSLcourses app' />
                </div>
              </div>
            </div>

            <div className='benefit-list__benefit'>
              <div className='l-container'>
                <div className='benefit-list__content'>
                  <h2 className='epsilon'>Nationally recognised qualifications</h2>
                  <h3>Get nationally recognised qualifications backed by iBSL and Signature</h3>
                  <p>When you complete any of our BSL Training Courses, you'll receive a certificate of completion from us. Whereas, if you choose a formal qualification course (for example, Level 1 Award), you will also receive a nationally-accredited certificate from their respective BSL Awarding body (iBSL or Signature).</p>
                </div>
                <div className='benefit-list__image benefit-list__image--qualifications'>
                  <img src={img4} alt='Nationally recognised qualifications' />
                </div>
              </div>
            </div>
          </section>
          <TestimonialsCarousel />
          <div className='l-container l-container--narrow'>
            <section className='island u-text-center'>
              <h2>We're hiring!</h2>
              <p>We are looking for an experienced and qualified BSL Teacher to join our team on a freelance basis.</p>
              <p><a href='/hiring' className='button button--s'>Find out more</a></p>
            </section>
          </div>

        </main>
      </span>
    );
  }
}

Home.propTypes = {
  courses: PropTypes.array
};

export default Home;



// WEBPACK FOOTER //
// ./src/views/Main/Home/index.js